<div class="container">
	<h2>{{ "get started" | i18next: { format: "capitalize" } }}</h2>
	<p>{{ "get started description" | i18next }}</p>
	<div style="display: flex; gap: 1em" *ngIf="(zoneService.hasOneDivision$ | async) === null">
		<mat-spinner diameter="20" color="accent"></mat-spinner>
		<div>{{ "loading divisions please wait" | i18next }}</div>
	</div>

	<div class="div-container" [class.invisible]="(showFilter$() | async) === false">
		<div class="label-filter" [class.invisible]="zoneService.hasOneDivision$ | async">
			<div>
				{{ "select the division with the assets you plan to assign rules to" | i18next }}:
				<span class="asterisk">*</span>
			</div>
			<app-division-filter-v2 [defaultDivisionId]="defaultDivId"></app-division-filter-v2>
		</div>
	</div>
</div>
